import React from 'react';
import { DatePicker as AntdDatePicker, DatePickerProps as AntdDatePickerProps } from 'antd';
import { CommonPickerMethods as AntdCommonPickerMethods } from 'antd/lib/date-picker/generatePicker/interface';

export type CommonPickerMethods = AntdCommonPickerMethods;
export type DatePickerProps = AntdDatePickerProps & {
	status?: '' | 'warning' | 'error';
	dropdownClassName?: string;
	popupClassName?: string;
};

const DatePicker = React.forwardRef<CommonPickerMethods, DatePickerProps>((props, ref) => (
	<AntdDatePicker
		{...props}
		// @ts-ignore as this is fixed on version 5.15.0
		ref={ref}
		className={`bringg-picker ${props.className || ''}`}
		popupClassName={`bringg-picker-dropdown ${props.popupClassName || ''} ${props.dropdownClassName || ''}`}
	/>
));

export default DatePicker;
